import strategyService from '../../../../core/services/Strategy/StrategyService';
import { getParamFromSortState } from '../../../helpers/Common';
import reducerRegistry from '../../../helpers/ReducerRegistry';

const REDUCER_NAME = 'FIINTRADE_CANSLIM_STRATEGY';
const FETCH_CANSLIM_DATA = `${REDUCER_NAME}FETCH_CANSLIM_DATA`;
const UPDATE_API_PARAMS = `${REDUCER_NAME}UPDATE_API_PARAMS`;
const LOAD_INVEST_DATA = `${REDUCER_NAME}LOAD_INVEST_DATA`;
const SET_LOADING = `${REDUCER_NAME}SET_LOADING`;
const HOVER_ROW = `${REDUCER_NAME}HOVER_ROW`;
const INIT_COMPONENT = `${REDUCER_NAME}INIT_COMPONENT`;
const UNMOUNT_COMPONENT = `${REDUCER_NAME}UNMOUNT_COMPONENT`;
const SET_SORT_STATE = `${REDUCER_NAME}SET_SORT_STATE`;

let mounted = true;

export { REDUCER_NAME, reducer as default };

export const setSortState = sortState => ({
  type: SET_SORT_STATE,
  payload: sortState,
});

export const fetchValueInvestment = () => {
  if (mounted) {
    return dispatch => {
      strategyService
        .getValueInvestment({ StrategyScoreType: 'CanSlim' })
        .then(response => {
          let { items = [] } = response === null ? [] : response || [];
          dispatch({
            type: LOAD_INVEST_DATA,
            payload: {
              investData: items && items.length ? items : [],
            },
          });
        });
    };
  }
};

export const fetchCanSlimData = (isSearch = false) => {
  return (dispatch, getState) => {
    dispatch(setLoading());
    const sortState = getState()[REDUCER_NAME].sortState;
    const params = {
      ...getState()[REDUCER_NAME].apiParams,
      ...getParamFromSortState(sortState),
    };
    if (isSearch) {
      params.Page = 1;
    }
    strategyService.getCanSlim(params).then(response => {
      let { items = [], totalCount, pageSize } =
        response === null ? [] : response || [];
      if (mounted) {
        dispatch({
          type: FETCH_CANSLIM_DATA,
          payload: {
            canSlimData: items && items.length ? items : [],
            totalPage: Math.ceil(totalCount / pageSize),
            isSearch,
          },
        });
      }
    });
  };
};

export const updateApiParams = apiParams => {
  return dispatch => {
    dispatch({
      type: UPDATE_API_PARAMS,
      payload: {
        apiParams,
      },
    });
    const isSearch = 'OrganCode' in apiParams;
    dispatch(fetchCanSlimData(isSearch));
  };
};

export const setLoading = () => {
  return dispatch => {
    dispatch({
      type: SET_LOADING,
      payload: {},
    });
  };
};

export const changeIdHover = item => dispatch => {
  const currentItemSearch = item || {};
  const ticker = item ? item.ticker || '' : '';
  const organCode = item ? item.organCode || '' : '';

  dispatch(updateApiParams({ OrganCode: organCode, Page: 1 }));
  dispatch({
    type: HOVER_ROW,
    payload: {
      ticker,
      currentItemSearch,
    },
  });
};

export const defaultSortState = { total: 'desc' };

const initialState = {
  canSlimData: [],
  apiParams: {
    Page: 1,
    PageSize: 50,
    OrganCode: null,
  },
  totalPage: null,
  isLoading: true,
  idHover: '',
  investData: {},
  currentItemSearch: {},
  isSearch: false,
  sortState: defaultSortState,
};

function reducer(state = {}, action) {
  switch (action.type) {
    case INIT_COMPONENT:
      mounted = true;
      return {
        ...state,
        ...initialState,
      };

    case UNMOUNT_COMPONENT:
      mounted = false;
      return {};

    case UPDATE_API_PARAMS:
      const { apiParams } = action.payload;
      return {
        ...state,
        apiParams: {
          ...state.apiParams,
          ...apiParams,
        },
      };

    case LOAD_INVEST_DATA: {
      const { investData } = action.payload;
      const valueInvestTable = [...investData];
      const valueInvestChart = investData.map(item => {
        return {
          ...item,
          averageIndex: item.averageIndex + 1,
          averageStock: item.averageStock + 1,
        };
      });
      return {
        ...state,
        investData: {
          ...state.investData,
          valueInvestTable,
          valueInvestChart,
          isFetching: false,
        },
      };
    }

    case HOVER_ROW:
      const { currentItemSearch, ticker } = action.payload;
      return {
        ...state,
        currentItemSearch,
        idHover: ticker,
        isSearch: !!Object.keys(currentItemSearch).length,
      };

    case SET_LOADING:
      return {
        ...state,
        isLoading: true,
      };

    case FETCH_CANSLIM_DATA:
      const { canSlimData, totalPage, isSearch } = action.payload;
      return {
        ...state,
        canSlimData: isSearch
          ? canSlimData
          : [...state.canSlimData, ...canSlimData],
        isLoading: false,
        totalPage,
      };

    case SET_SORT_STATE:
      return {
        ...state,
        sortState: action.payload,
      };

    default:
      return state;
  }
}

reducerRegistry.register(REDUCER_NAME, reducer);
